import { useMediaContext } from '../MediaContext';
import { useDominantSpeaker } from './useDominantSpeaker';
import { useParticipants } from './useParticipants';
import { useScreenShareParticipant } from './useScreenShareParticipant';
import { useSelectedParticipant } from './useSelectedParticipant';
export const useMainParticipant = () => {
    var _a, _b, _c;
    const [selectedParticipant] = useSelectedParticipant();
    const screenShareParticipant = useScreenShareParticipant();
    const dominantSpeaker = useDominantSpeaker();
    const participants = useParticipants();
    const { room } = useMediaContext();
    const localParticipant = room === null || room === void 0 ? void 0 : room.localParticipant;
    const remoteScreenShareParticipant = screenShareParticipant !== localParticipant ? screenShareParticipant : null;
    return ((_c = (_b = (_a = selectedParticipant !== null && selectedParticipant !== void 0 ? selectedParticipant : remoteScreenShareParticipant) !== null && _a !== void 0 ? _a : dominantSpeaker) !== null && _b !== void 0 ? _b : participants[0]) !== null && _c !== void 0 ? _c : localParticipant);
};
//# sourceMappingURL=useMainParticipant.js.map